import axios from "axios";
import { apiUrl } from "./helpers/common";

const user = JSON.parse(localStorage.getItem("webuser"));
const token = user && user.token ? "Bearer " + user.token : "";

export default axios.create({
	baseURL: apiUrl(),
	headers: {
		"Content-type": "application/json",
		Authorization: token,
	},
});
